import { Label as HeadlessLabel } from '@headlessui/react';

export function Label({
	action,
	children,
}: Readonly<{ action?: React.ReactNode; children: React.ReactNode }>) {
	return (
		<div className="flex items-center justify-between gap-x-2">
			<HeadlessLabel className="block text-base font-medium text-black">
				{children}
			</HeadlessLabel>
			{action && (
				<>
					<span className="flex-1" /> {action}
				</>
			)}
		</div>
	);
}
